import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { api } from "@/lib/api";

const FALLBACK_POSTER =
  "https://images.unsplash.com/photo-1741356474365-5f0041f89eaa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBibGFjayUyMGdvbGQlMjBidXNpbmVzcyUyMGFic3RyYWN0JTIwYmFja2dyb3VuZCUyMGFyY2hpdGVjdHVyZSUyMGV4ZWN1dGl2ZSUyMGZpbmFuY2lhbCUyMHdlYWx0aHxlbnwwfHx8fDE3ODk4NDI5NDJ8MA&ixlib=rb-4.1.0&q=85";

export default function VideoSection() {
  const [cfg, setCfg] = useState(null);
  const [playing, setPlaying] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    api.get("/settings/public").then((r) => setCfg(r.data)).catch(() => setCfg({}));
  }, []);

  const poster = cfg?.video_poster || FALLBACK_POSTER;

  return (
    <section className="relative py-24 lg:py-36 px-5 lg:px-8" data-testid="promo-video-section">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="flex items-end justify-between mb-10"
        >
          <div>
            <p className="font-mono-num text-xs tracking-[0.35em] text-[#D4AF37] mb-4">BRAND FILM · 宣传片</p>
            <h2 className="font-serif-sc text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
              走进<span className="text-gold-grad">合赢</span>
            </h2>
          </div>
          <p className="hidden md:block max-w-xs text-sm text-gray-500 leading-relaxed">
            一支影片，看懂合赢如何为成员筛选可靠、零风险的赚钱项目。
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="relative max-w-5xl mx-auto"
        >
          <div className="absolute -inset-6 bg-[#D4AF37]/5 blur-3xl -z-10" />
          <div
            data-testid="promo-video-container"
            className="relative aspect-video border border-[#D4AF37]/30 gold-glow bg-black overflow-hidden"
          >
            <span className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-[#D4AF37] z-10" />
            <span className="absolute top-0 right-0 w-6 h-6 border-t-2 border-r-2 border-[#D4AF37] z-10" />
            <span className="absolute bottom-0 left-0 w-6 h-6 border-b-2 border-l-2 border-[#D4AF37] z-10" />
            <span className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-[#D4AF37] z-10" />
            <video
              ref={videoRef}
              data-testid="promo-video-player"
              className="w-full h-full object-cover"
              src={cfg?.video_url || undefined}
              poster={poster}
              controls={playing}
              preload="metadata"
              playsInline
            />
            {!playing && (
              <button
                data-testid="promo-video-play-btn"
                onClick={() => {
                  setPlaying(true);
                  videoRef.current?.play();
                }}
                className="absolute inset-0 z-10 grid place-items-center bg-black/45 group"
                aria-label="播放宣传片"
              >
                <span className="relative pulse-ring grid place-items-center w-20 h-20 rounded-full border border-[#D4AF37]/70 bg-[#070709]/70 backdrop-blur transition-transform duration-500 group-hover:scale-110">
                  <Play className="w-7 h-7 text-[#D4AF37] ml-1" fill="currentColor" />
                </span>
              </button>
            )}
          </div>
          <div className="mt-4 flex items-center justify-between text-xs text-gray-600 font-mono-num tracking-widest">
            <span>HEYING OFFICIAL PROMO · 16:9</span>
            <span>合赢项目交流社区</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
